var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargillHedgitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 362.47 363.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#303d4d;}.cls-2{fill:#398245;}.cls-3{fill:#fff;}.cls-4{fill:url(#Degradado_sin_nombre_8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8",
    x1: 156.03,
    y1: 6.43,
    x2: 348.28,
    y2: 368.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0a0f19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#303b4c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M293.97,362.83H106.3c1.5-120.86,2.99-241.73,4.49-362.59,61.06-.08,122.12-.16,183.18-.25v362.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.59,362.02c-24.82-.91-51.59,1.97-76.2.26-17.17-1.19-29.9-9.52-34.16-26.74L0,28.21C1.94,14.05,13.53,2.26,27.7,0l83.09.25,112.25,164.33c5.51,10.65,5.73,22.87-.63,33.2l-111.82,164.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.69.24l-80.04-.24c-2.21.03-4.37.28-6.44.75C13.01,3.83,3.94,12.89.81,24.04c-.52,2.27-.81,4.62-.81,7.05v132.03l.13,172.37c.05.54.11,1.07.18,1.6,4.41,16.83,17.02,25.01,33.98,26.19,24.61,1.71,51.38-1.18,76.2-.26l111.82-164.7c6.36-10.35,6.14-22.61.63-33.29C185.52,110.09,148.11,55.17,110.69.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M336.91,0c11.68,1.96,24.56,16.58,25.44,28.5l.05,303.89c1.24,12.25-15.89,30.44-27.5,30.44h-186.18l111.23-164.01c6.47-9.7,6.27-23.65,1.02-33.84L148.73,0h188.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.73.19h188.16c11.68,1.96,24.56,16.56,25.44,28.46,0,43.16.02,86.32.02,129.48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargillHedgitIcon);
export default __webpack_public_path__ + "static/media/cargill-hedgit-icon.f65017ca64a5cce5f6a76f5dcec635db.svg";
export { ForwardRef as ReactComponent };